/* eslint-disable no-nested-ternary */
import { Row, Col, Space, Typography, Input } from 'antd';
import { Field, Header } from 'pages/rules/utils/FormulaComponents';

const { Text } = Typography;

export const PercentageFormula = (p: any) => {
  const {
    currentConfig: { fields },
  } = p;
  return (
    <Space direction="vertical" className="w-full" size="middle">
      <Header p={p} tKey="common.formula" />
      <Row className="formula-builder-container" gutter={8} align="middle">
        <Col>
          <Text strong>(</Text>
        </Col>
        <Col span={8} flex="200px">
          <Field
            p={p}
            val={fields.field1}
            keyName="field1"
            placeholder="Select Field1"
          />
        </Col>
        <Col>
          <Text strong>/ 100 ) </Text>
        </Col>
        <Col>
          <Text strong>*</Text>
        </Col>
        <Col flex="200px">
          <Field
            p={p}
            val={fields.field2}
            keyName="field2"
            placeholder="Select Field2"
          />
        </Col>
      </Row>
    </Space>
  );
};

export const FlatFormula = (p: any) => {
  const {
    t,
    currentConfig: { fields },
  } = p;
  return (
    <Space direction="vertical" className="w-full" size="middle">
      <Header p={p} tKey="simplePayoutBuilder.formula" />
      <Row className="formula-builder-container" gutter={8} align="middle">
        <Col span={4}>
          <Text strong>{t('simplePayoutBuilder.field1')}:</Text>
        </Col>
        <Col flex="200px">
          <Field
            p={p}
            val={fields.field1}
            keyName="field1"
            placeholder="Select Field1"
          />
        </Col>
      </Row>
    </Space>
  );
};

export const FlatWithConstraints = (p: any) => {
  const {
    currentConfig: { type, fields },
    t,
    handleFieldChange,
    disabled,
  } = p;
  return (
    <Space direction="vertical" className="w-full" size="middle">
      <Header p={p} tKey="simplePayoutBuilder.formula" />
      <Row
        className="formula-builder-container"
        gutter={8}
        align="middle"
        wrap={false}
      >
        {type.includes('min') ? (
          <>
            <Col>
              <Text strong>{t('simplePayoutBuilder.max')}(</Text>
            </Col>
            {type.includes('min_fixed') ? (
              <Col flex="200px">
                <Input
                  placeholder="Min value"
                  type="number"
                  value={fields.minValue}
                  onChange={(e) =>
                    handleFieldChange('minValue', e.target.value)
                  }
                  disabled={disabled}
                />
              </Col>
            ) : null}
            {type.includes('min_variable') ? (
              <Field
                p={p}
                val={fields.minField}
                keyName="minField"
                placeholder="Min Field"
              />
            ) : null}
            <Col>
              <Text strong>,</Text>
            </Col>
          </>
        ) : null}
        {type.includes('max') ? (
          <>
            <Col>
              <Text strong>{t('simplePayoutBuilder.min')}(</Text>
            </Col>
            {type.includes('max_fixed') ? (
              <Col flex="200px">
                <Input
                  placeholder="Max value"
                  type="number"
                  value={fields.maxValue}
                  onChange={(e) =>
                    handleFieldChange('maxValue', e.target.value)
                  }
                  disabled={disabled}
                />
              </Col>
            ) : null}
            {type.includes('max_variable') ? (
              <Field
                p={p}
                val={fields.maxField}
                keyName="maxField"
                placeholder="Max Field"
              />
            ) : null}
            <Col>
              <Text strong>,</Text>
            </Col>
          </>
        ) : null}
        <Col flex="200px">
          <Field
            p={p}
            val={fields.field1}
            keyName="field1"
            placeholder="Field1"
          />
        </Col>
        {type.includes('max') ? (
          <Col>
            <Text strong>)</Text>
          </Col>
        ) : null}
        {type.includes('min') ? (
          <Col>
            <Text strong>)</Text>
          </Col>
        ) : null}
      </Row>
    </Space>
  );
};

export const PercentageWithConstraints = (p: any) => {
  const {
    currentConfig: { type, fields },
    t,
    handleFieldChange,
    disabled,
  } = p;
  return (
    <Space direction="vertical" className="w-full" size="middle">
      <Header p={p} tKey="common.formula" />
      <Row
        className="formula-builder-container"
        gutter={8}
        align="middle"
        wrap={false}
      >
        {type.includes('min') ? (
          <>
            <Col>
              <Text strong>{t('simplePayoutBuilder.max')}(</Text>
            </Col>
            {type.includes('min_fixed') ? (
              <Col flex="200px">
                <Input
                  placeholder="Min value"
                  type="number"
                  value={fields.minValue}
                  onChange={(e) =>
                    handleFieldChange('minValue', e.target.value)
                  }
                  disabled={disabled}
                />
              </Col>
            ) : null}
            {type.includes('min_variable') ? (
              <Field
                p={p}
                val={fields.minField}
                keyName="minField"
                placeholder="Min Field"
              />
            ) : null}
            <Col>
              <Text strong>,</Text>
            </Col>
          </>
        ) : null}
        {type.includes('max') ? (
          <>
            <Col>
              <Text strong>{t('simplePayoutBuilder.min')}(</Text>
            </Col>
            {type.includes('max_fixed') ? (
              <Col flex="200px">
                <Input
                  placeholder="Max value"
                  type="number"
                  value={fields.maxValue}
                  onChange={(e) =>
                    handleFieldChange('maxValue', e.target.value)
                  }
                  disabled={disabled}
                />
              </Col>
            ) : null}
            {type.includes('max_variable') ? (
              <Field
                p={p}
                val={fields.maxField}
                keyName="maxField"
                placeholder="Max Field"
              />
            ) : null}
            <Col>
              <Text strong>,</Text>
            </Col>
          </>
        ) : null}
        <Col>
          <Text strong>((</Text>
        </Col>
        <Col flex="200px">
          <Field
            p={p}
            val={fields.field1}
            keyName="field1"
            placeholder="Field1 %"
          />
        </Col>
        <Col>
          <Text strong>/ 100) *</Text>
        </Col>
        <Col flex="200px">
          <Field
            p={p}
            val={fields.field2}
            keyName="field2"
            placeholder="Field2"
          />
        </Col>
        <Col>
          <Text strong>)</Text>
        </Col>
        {type.includes('max') ? (
          <Col>
            <Text strong>)</Text>
          </Col>
        ) : null}
        {type.includes('min') ? (
          <Col>
            <Text strong>)</Text>
          </Col>
        ) : null}
      </Row>
    </Space>
  );
};
